/**
 * Guarda el pathname actual en una cookie llamada "lastPathRedirect"
 * Extrae automáticamente solo la parte del producto, excluyendo la parte base de la aplicación
 * @param pathname - El pathname actual que se quiere guardar
 * @param maxAge - Tiempo de vida de la cookie en segundos (opcional, por defecto 24 horas)
*/

import { createCookie, getValueCookie, removeCookie } from "./cookies";
import { getCurrentBasePath } from "./BasePathTools";
import { ROUTE_PATHS } from "./constants";

const LAST_PATH_REDIRECT_COOKIE = "lastPathRedirect";

function extractProductPathname(pathname: string): string {
  const basePath = getCurrentBasePath();

  if (pathname.startsWith(basePath)) {
    const productPath = pathname.substring(basePath.length);
    return productPath.startsWith('/') ? productPath : `/${productPath}`;
  }

  return pathname;
}

export function saveLastPathRedirect(pathname: string, maxAge: number = 86400): void {
  if (!pathname || pathname.trim() === "") {
    return;
  }

  const productPathname = extractProductPathname(pathname);

  try {
    sessionStorage.setItem(LAST_PATH_REDIRECT_COOKIE, productPathname);
  } catch (error) {
    // Redirect persistence is best effort and must not block navigation.
  }

  createCookie(LAST_PATH_REDIRECT_COOKIE, productPathname, maxAge);
}

export function getLastPathRedirect(includeBasePath: boolean = false): string {
  const savedPathname =
    sessionStorage.getItem(LAST_PATH_REDIRECT_COOKIE) ??
    getValueCookie(LAST_PATH_REDIRECT_COOKIE);

  if (!savedPathname) {
    return ROUTE_PATHS.PRODUCTS;
  }

  if (includeBasePath) {
    const basePath = getCurrentBasePath();
    return `${basePath}${savedPathname.startsWith('/') ? savedPathname.substring(1) : savedPathname}`;
  }

  return savedPathname;
}

export function clearLastPathRedirect(): void {
  try {
    sessionStorage.removeItem(LAST_PATH_REDIRECT_COOKIE);
    removeCookie(LAST_PATH_REDIRECT_COOKIE);
  } catch (error) {
    // Cleanup is best effort when browser storage is unavailable.
  }
} 